import { atom } from 'recoil'

const missingInformationAtom = atom({
    key: 'missingInformation',
    default: {}
})

export default missingInformationAtom